import gsap from 'gsap';
import { SplitText } from 'gsap/SplitText';

gsap.registerPlugin(SplitText);

import { GetBy } from "../_app/cuchillo/core/Element";
import { isDebug } from '../_app/cuchillo/core/Basics';
import { Ease } from '../_app/cuchillo/utils/Ease';

export default class Curtain {
    _container;
    _logo;
    _lines;
    _cols;
    _paths;

    static init() {
        this._container = GetBy.id('Curtain');

        this._cols = GetBy.selector('.grid-cols span', this._container);
        gsap.set(this._cols, { scaleX: 0, opacity: 1 });
    }

    static show(__call) {
        if (isDebug) {
            if (__call) __call();
            return;
        }

        let delay = 0;
        let call = () => { };

        for (let i = 0; i < this._cols.length; i++) {
            if (i === this._cols.length - 1) call = __call;

            const line = this._cols[i];
            line.style.transformOrigin = 'center right';
            gsap.to(line, {
                scaleX: 1,
                delay: delay + i * .08,
                duration: 1,
                ease: Ease.EASE_CUCHILLO_IN_OUT,
                onComplete: () => {
                    line.style.transformOrigin = 'center left';
                    call();
                }
            });
        }
    }

    static hide(__call) {
        if (isDebug) {
            if (__call) __call();
            return;
        }

        let delay = 0;
        let call = () => { };

        for (let i = 0; i < this._cols.length; i++) {
            if (i === this._cols.length - 1) call = __call;

            const line = this._cols[i];
            gsap.to(line, {
                scaleX: 0,
                delay: delay + i * .05,
                duration: 1,
                ease: Ease.EASE_CUCHILLO_IN_OUT,
                onComplete: () => {
                    call();
                }
            });
        }
    }
}
